"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CheckIcon_1 = __importDefault(require("../common/FirstSection/CheckIcon"));
var styles_1 = require("../common/styles");
var List_1 = __importDefault(require("../common/List"));
var magnet1_png_1 = __importDefault(require("./assets/magnet1.png"));
var magnet2_png_1 = __importDefault(require("./assets/magnet2.png"));
var magnet3_png_1 = __importDefault(require("./assets/magnet3.png"));
var magnet4_png_1 = __importDefault(require("./assets/magnet4.png"));
var magnet5_png_1 = __importDefault(require("./assets/magnet5.png"));
var magnet6_png_1 = __importDefault(require("./assets/magnet6.png"));
var magnet7_png_1 = __importDefault(require("./assets/magnet7.png"));
var magnet8_png_1 = __importDefault(require("./assets/magnet8.png"));
var magnet9_png_1 = __importDefault(require("./assets/magnet9.png"));
var bg_png_1 = __importDefault(require("./FirstSection/bg.png"));
exports.default = {
    bgimageStyle: "\n        max-width: 708px;\n        top: -20px;\n        right: -20px;\n        ",
    FirstSectionBgImage: bg_png_1.default,
    axiosLink: '/api/products/square_magnet50x50?format=json',
    productLink: '/square_magnets50x50/new_v2',
    productNamePlural: 'магниты',
    seoText: (react_1.default.createElement(styles_1.Text, null, "\u041A\u0443\u0440\u043E\u0440\u0442\u044B \u0441\u0434\u0435\u043B\u0430\u043B\u0438 \u0438\u0437 \u043D\u0438\u0445 \u0430\u043D\u0442\u0438\u043C\u0430\u0441\u0442\u0445\u0435\u0432, \u043D\u043E \u0441\u0432\u043E\u0435\u0439 \u043F\u043E\u043B\u044C\u0437\u044B \u043E\u043D\u0438 \u043D\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u043B\u0438. \u041C\u0430\u0433\u043D\u0438\u0442\u0430\u043C\u0438 \u0443\u0434\u043E\u0431\u043D\u043E \u0437\u0430\u043A\u0440\u0435\u043F\u0438\u0442\u044C \u0447\u0442\u043E-\u0442\u043E \u043D\u0430 \u0431\u0438\u043B\u0431\u043E\u0440\u0434\u0435, \u0445\u043E\u043B\u043E\u0434\u0438\u043B\u044C\u043D\u0438\u043A\u0435, \u0434\u043E\u0441\u043A\u0435 \u0432\u0438\u0437\u0443\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438. \u0413\u043B\u0430\u0432\u043D\u043E\u0435 \u2013 \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u0435. \u041F\u0435\u0447\u0430\u0442\u044C \u043D\u0430 \u043C\u0430\u0433\u043D\u0438\u0442\u0430\u0445 \u043F\u043E\u043C\u043E\u0436\u0435\u0442 \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u0438\u0445 \u043D\u0435 \u0442\u043E\u043B\u044C\u043A\u043E \u043F\u043E\u043B\u0435\u0437\u043D\u044B\u043C\u0438, \u043D\u043E \u0438 \u043A\u043E\u043D\u0446\u0435\u043F\u0442\u0443\u0430\u043B\u044C\u043D\u044B\u043C\u0438. \u0423 \u043D\u0430\u0441 \u043C\u043E\u0436\u043D\u043E \u0437\u0430\u043A\u0430\u0437\u0430\u0442\u044C \u043C\u0430\u0433\u043D\u0438\u0442 \u0441 \u043B\u043E\u0433\u043E\u0442\u0438\u043F\u043E\u043C \u0438\u043B\u0438 \u043B\u044E\u0431\u044B\u043C \u0434\u0440\u0443\u0433\u0438\u043C \u0440\u0438\u0441\u0443\u043D\u043A\u043E\u043C, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0443 \u0434\u0438\u0437\u0430\u0439\u043D\u0430. \u042F\u0440\u043A\u0438\u0435 \u0438 \u043A\u043B\u0430\u0441\u0441\u043D\u044B\u0435 \u2013 \u0442\u0430\u043A\u0438\u0435 \u043C\u0430\u0433\u043D\u0438\u0442\u0438\u043A\u0438 \u0442\u043E\u0447\u043D\u043E \u0431\u0443\u0434\u0443\u0442 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C!")),
    firstSectionTitle: (react_1.default.createElement(styles_1.MainTitle, null,
        "\u041F\u0435\u0447\u0430\u0442\u044C \u043C\u0430\u0433\u043D\u0438\u0442\u043E\u0432",
        react_1.default.createElement("br", null),
        " \u043D\u0430 \u0437\u0430\u043A\u0430\u0437")),
    firstSectionText: (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.Text, null, "\u041C\u0430\u0433\u043D\u0438\u0442\u044B \u0440\u0430\u0437\u043D\u043E\u0439 \u0444\u043E\u0440\u043C\u044B \u0441 \u043B\u043E\u0433\u043E\u0442\u0438\u043F\u0430\u043C\u0438, \u043D\u0430\u0434\u043F\u0438\u0441\u044F\u043C\u0438, \u0440\u0438\u0441\u0443\u043D\u043A\u0430\u043C\u0438 \u043E\u0442 1 \u0448\u0442."),
        react_1.default.createElement(List_1.default, { icon: react_1.default.createElement(CheckIcon_1.default, null) },
            react_1.default.createElement(styles_1.Text, null, "\u041A\u043E\u0440\u043F\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u044B\u0435 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u044B \u0438 \u0441\u0443\u0432\u0435\u043D\u0438\u0440\u044B \u043F\u043E\u0434 \u043A\u043B\u044E\u0447"),
            react_1.default.createElement(styles_1.Text, null, "\u041F\u043E\u043C\u043E\u0449\u044C \u0434\u0438\u0437\u0430\u0439\u043D\u0435\u0440\u0430"),
            react_1.default.createElement(styles_1.Text, null, "\u0418\u0437\u0433\u043E\u0442\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0432 \u0434\u0435\u043D\u044C \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F"),
            react_1.default.createElement(styles_1.Text, null, "\u0421\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0435 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u043E")))),
    productsTitle: 'Магниты для нанесения',
    products: [
        {
            link: '/square_magnets50x50/new_v2',
            image: magnet1_png_1.default,
            text: 'Магниты квадратные, 5 на 5 см',
        },
        {
            image: magnet2_png_1.default,
            text: 'Магниты круглые, 9,5 на 9,5 см',
        },
        {
            link: '/heart_magnets75x97/new_v2',
            image: magnet3_png_1.default,
            text: 'Магниты-сердца 7,5 на 9,7 см',
        },
        {
            link: '/star_magnets75x75/new_v2',
            image: magnet4_png_1.default,
            text: 'Магниты-звезды 7,5 на 7,5 см',
        },
        {
            image: magnet5_png_1.default,
            text: 'Магниты свободной формы',
        },
        {
            link: '/round_magnets50x50/new_v2',
            image: magnet6_png_1.default,
            text: 'Магниты круглые, 5 на 5 см',
        },
        {
            link: '/square_magnets95x95/new_v2',
            image: magnet7_png_1.default,
            text: 'Магниты квадратные 9,5 на 9,5 см',
        },
        {
            link: '/rectangle_magnets150x45/new_v2',
            image: magnet8_png_1.default,
            text: 'Магниты прямоугольные 15 на 4,5 см',
        },
        {
            image: magnet9_png_1.default,
            text: 'Магниты овальные 9,8 на 7 см',
        },
    ]
};
